const suggestedUserStructure = {
    userId: "",
    name: {
      firstName: "",
      lastName: ""
    },
    imageUrl: "",
    gender: "",
    ethenic: "",
    email: "",
    password: "",
    mobileNumber: "",
    devices: [],
    dateOfBirth: "",
    address: {
        street: "",
        city: "",
        state: "",
        zipCode: "",
        country: ""
    },
    users: [
    {
        userId: "", // Unique User ID
        userName: "",
        useruuid: "",
        location: "",
        profileImage: "",
        joinedon: "",
        activelevel: "",
    }
    ]
}

export default suggestedUserStructure;